import { useTownStore } from "../state/store";
import { Dialog } from "./Dialog";

/**
 * Report action stub (brief section 5). It sends nothing in M1 and says so: the moderation
 * milestone adds the protected report record with a snapshot of the listing (docs/08 section 6).
 */
export function ReportDialog() {
  const open = useTownStore((s) => s.ui.reportOpen);
  const propertyId = useTownStore((s) => s.ui.selectedPropertyId);
  const property = useTownStore((s) => (s.ui.selectedPropertyId ? s.properties[s.ui.selectedPropertyId] : undefined));
  const setUi = useTownStore((s) => s.setUi);
  if (!open || !propertyId) return null;
  const name = property?.placement?.businessName ?? property?.address ?? propertyId;
  const close = () => setUi({ reportOpen: false });
  return (
    <Dialog
      title={`Report ${name}`}
      onClose={close}
      footer={
        <>
          <button type="button" className="btn btn-primary" data-autofocus onClick={close}>
            Got it
          </button>
        </>
      }
    >
      <p>
        <strong>Reporting is not wired up yet in this milestone — nothing has been sent.</strong>
      </p>
      <p className="muted">
        When the moderation milestone lands, this action will create a protected report with a snapshot of the listing (name,
        description, destination) and the time you saw it, for human review. Reporters are never shown publicly.
      </p>
    </Dialog>
  );
}
